import type { SvgIconComponent } from '@mui/icons-material';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import TextureOutlinedIcon from '@mui/icons-material/TextureOutlined';
import CheckroomOutlinedIcon from '@mui/icons-material/CheckroomOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import WallpaperOutlinedIcon from '@mui/icons-material/WallpaperOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import RecordVoiceOverOutlinedIcon from '@mui/icons-material/RecordVoiceOverOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import MoodOutlinedIcon from '@mui/icons-material/MoodOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';

/**
 * Maps a parameter-palette `kind` to a representative glyph so the SwatchPanel
 * group headers are scannable at a glance. Kinds mirror those seeded in
 * `StudioSeedData.cs`; anything unmapped falls back to a neutral category icon.
 */
const ICON_BY_KIND: Record<string, SvgIconComponent> = {
  style: BrushOutlinedIcon,
  'aspect-ratio': AspectRatioOutlinedIcon,
  'studio-filter': TuneOutlinedIcon,
  material: LayersOutlinedIcon,
  fabric: TextureOutlinedIcon,
  'garment-type': CheckroomOutlinedIcon,
  pose: AccessibilityNewOutlinedIcon,
  print: GridOnOutlinedIcon,
  background: WallpaperOutlinedIcon,
  lighting: LightModeOutlinedIcon,
  'camera-angle': CameraAltOutlinedIcon,
  'product-type': Inventory2OutlinedIcon,
  'ad-style': CampaignOutlinedIcon,
  genre: MenuBookOutlinedIcon,
  voice: RecordVoiceOverOutlinedIcon,
  pov: VisibilityOutlinedIcon,
  pacing: SpeedOutlinedIcon,
  audience: GroupsOutlinedIcon,
  format: ArticleOutlinedIcon,
  tone: MoodOutlinedIcon,
  'campaign-type': CampaignOutlinedIcon,
  platform: ShareOutlinedIcon,
  tier: WorkspacePremiumOutlinedIcon,
  'camera-motion': VideocamOutlinedIcon,
  duration: TimerOutlinedIcon,
  color: PaletteOutlinedIcon,
};

export function paletteKindIcon(kind: string): SvgIconComponent {
  return ICON_BY_KIND[kind.toLowerCase()] ?? CategoryOutlinedIcon;
}
